import { render, staticRenderFns } from "./FormPermissionManager.vue?vue&type=template&id=2bb9f624&scoped=true&"
import script from "./FormPermissionManager.vue?vue&type=script&lang=js&"
export * from "./FormPermissionManager.vue?vue&type=script&lang=js&"
import style0 from "./FormPermissionManager.vue?vue&type=style&index=0&id=2bb9f624&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb9f624",
  null
  
)

export default component.exports